import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { authStorage } from '../authStorage';
import { WEB_CONFIG } from '../config';

/**
 * `supabase/client.ts`'nin web karşılığı. Masaüstünde oturum işletim
 * sisteminin anahtar zinciriyle şifrelenip diske yazılıyor; tarayıcıda
 * supabase-js'in varsayılanı (localStorage) kullanılıyor. Bu yüzden web
 * uygulamasında sıkı CSP şart (webapp/public/_headers): bir XSS oturumu
 * okuyabilirdi.
 *
 * Giriş Google'a yönlendirme ile (PKCE); dönüşte adres çubuğundaki `code`
 * istemci kurulurken oturuma çevriliyor (`detectSessionInUrl`).
 *
 * Yalnızca ANON anahtar — erişim denetimi RLS'te (masaüstüyle aynı).
 */

/** Masaüstündeki gibi: PostgREST'in bayat saat önbelleği (PGRST303) için kısa yeniden deneme. */
async function fetchWithIatRetry(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  let res = await fetch(input, init);
  for (const delayMs of [1_000, 2_000, 4_000]) {
    if (res.status !== 401) return res;
    const body = (await res.clone().json().catch(() => null)) as { code?: string } | null;
    if (body?.code !== 'PGRST303') return res;
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    res = await fetch(input, init);
  }
  return res;
}

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    if (!isSupabaseConfigured()) throw new Error('Supabase yapılandırılmamış (SUPABASE_URL / SUPABASE_ANON_KEY).');
    client = createClient(WEB_CONFIG.supabaseUrl, WEB_CONFIG.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
        storageKey: 'talknote-oturum',
        // Web'de tanımsız (localStorage); mobilde güvenli depo.
        storage: authStorage,
      },
      global: { fetch: fetchWithIatRetry },
    });
  }
  return client;
}

export function isSupabaseConfigured(): boolean {
  return Boolean(WEB_CONFIG.supabaseUrl && WEB_CONFIG.supabaseAnonKey);
}
